import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import Recipes from '../../components/Admin/Inventory/Recipes';

/**
 * Recipes Page
 * Manage recipes in Inventory module
 */
export default function RecipesPage() {
  return (
    <ModuleLayout>
      <Recipes />
    </ModuleLayout>
  );
}
